import React from 'react';
import { Mic, Users, Sparkles, Quote } from 'lucide-react';
import { methodValues, featureQuote } from '../mock';

const iconMap = { Mic, Users, Sparkles };

const Method = () => {
  return (
    <section id="metodo" className="bg-[#FAF6EC] py-20 md:py-24 relative overflow-hidden">
      <div className="absolute right-8 top-24 grid grid-cols-6 gap-1.5 opacity-25">
        {Array.from({ length: 36 }).map((_, i) => (
          <span key={i} className="w-1 h-1 rounded-full bg-[#1E3A5F]" />
        ))}
      </div>

      <div className="mx-auto max-w-7xl px-6 lg:px-10 relative">
        <div className="mb-12">
          <span className="inline-block text-[11px] font-semibold tracking-widest text-[#9B2C3B] px-3 py-1 border border-[#9B2C3B]/40 rounded-full">
            MÁS QUE UN CURSO
          </span>
          <h2 className="mt-5 font-serif text-4xl md:text-5xl leading-[1.05] font-bold text-[#1E3A5F] max-w-2xl">
            Más que inglés,{' '}
            <span className="text-[#5B84A6] italic">confianza.</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 grid sm:grid-cols-2 gap-6">
            {methodValues.map((v) => {
              const Icon = iconMap[v.icon];
              return (
                <div
                  key={v.id}
                  className="bg-white rounded-2xl p-7 border border-[#1E3A5F]/8 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all"
                >
                  <span className="h-11 w-11 rounded-full bg-[#FAF6EC] border border-[#E8B84A] flex items-center justify-center">
                    <Icon className="h-5 w-5 text-[#9B2C3B]" />
                  </span>
                  <h3 className="mt-5 font-serif text-xl font-bold text-[#1E3A5F]">
                    {v.title}
                  </h3>
                  <p className="mt-2 text-[13.5px] text-[#1E3A5F]/70 leading-relaxed">
                    {v.description}
                  </p>
                </div>
              );
            })}
          </div>

          <div className="bg-[#5B84A6] rounded-2xl p-8 text-white flex flex-col justify-between shadow-lg relative overflow-hidden">
            <div className="absolute -bottom-8 -right-8 h-40 w-40 rounded-full bg-white/10" />
            <Quote className="h-8 w-8 text-[#E8B84A]" fill="currentColor" />
            <p className="font-serif text-2xl leading-tight mt-6 relative">
              {featureQuote.text}
            </p>
            <div className="mt-8 flex items-center gap-3 relative">
              <div className="h-10 w-10 rounded-full bg-[#E8B84A] text-[#1E3A5F] flex items-center justify-center font-serif font-bold text-xs">
                PE
              </div>
              <div>
                <div className="text-[13px] font-semibold">{featureQuote.author}</div>
                <div className="text-[11px] text-white/70">{featureQuote.role}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Method;
